import { TagType } from '@common/api';
export var DroppableType;
(function (DroppableType) {
    DroppableType[DroppableType["Unknown"] = 0] = "Unknown";
    DroppableType[DroppableType["Empty"] = 1] = "Empty";
    DroppableType[DroppableType["Finder"] = 2] = "Finder";
    DroppableType[DroppableType["TagSidebar"] = 3] = "TagSidebar";
    DroppableType[DroppableType["SingleValueWidget"] = 4] = "SingleValueWidget";
    DroppableType[DroppableType["PivotWidget"] = 5] = "PivotWidget";
    DroppableType[DroppableType["ModelCustomColumn"] = 6] = "ModelCustomColumn";
})(DroppableType || (DroppableType = {}));
export var SingleValueZone;
(function (SingleValueZone) {
    SingleValueZone["Variable"] = "Variable";
    SingleValueZone["Filter"] = "Filter";
    SingleValueZone["Comparison"] = "Comparison";
})(SingleValueZone || (SingleValueZone = {}));
export var PivotZone;
(function (PivotZone) {
    PivotZone["Filter"] = "Filter";
    PivotZone["Column"] = "Column";
    PivotZone["Row"] = "Row";
    PivotZone["Variable"] = "Variable";
})(PivotZone || (PivotZone = {}));
export var DraggableType;
(function (DraggableType) {
    DraggableType[DraggableType["Unknown"] = 0] = "Unknown";
    DraggableType[DraggableType["Cluster"] = 1] = "Cluster";
    DraggableType[DraggableType["Tag"] = 2] = "Tag";
})(DraggableType || (DraggableType = {}));
export var DraggableTagType;
(function (DraggableTagType) {
    DraggableTagType["AccountTable"] = "AccountTable";
    DraggableTagType["Account"] = "Account";
    DraggableTagType["Dimension"] = "Dimension";
    DraggableTagType["Table"] = "Table";
    DraggableTagType["Unknown"] = "Unknown";
    DraggableTagType["Property"] = "Property";
})(DraggableTagType || (DraggableTagType = {}));
export function getDraggableTagType(tagType) {
    if (tagType === TagType.Account) {
        return DraggableTagType.Account;
    }
    else if (tagType === TagType.Table) {
        return DraggableTagType.Table;
    }
    else if (tagType === TagType.Dimension) {
        return DraggableTagType.Dimension;
    }
    else {
        return DraggableTagType.Unknown;
    }
}
export function createDroppableId(info) {
    return JSON.stringify(info);
}
export function parseDroppableId(info) {
    var parsedInfo = undefined;
    try {
        parsedInfo = JSON.parse(info);
    }
    catch (err) {
        parsedInfo = undefined;
    }
    return parsedInfo !== null && parsedInfo !== void 0 ? parsedInfo : { type: DroppableType.Unknown };
}
export function createDraggableId(info) {
    return JSON.stringify(info);
}
export function parseDraggableId(info) {
    var parsedInfo = undefined;
    try {
        parsedInfo = JSON.parse(info);
    }
    catch (err) {
        parsedInfo = undefined;
    }
    return parsedInfo !== null && parsedInfo !== void 0 ? parsedInfo : { type: DraggableType.Unknown };
}
